<script lang="ts">
	import TechnicalParameter from './TechnicalParameter.svelte';
	import Breadcrumb from '../../../components/Breadcrumb.svelte';
	import ScooterDetailNavigator from '../../../components/ScooterDetailNavigator.svelte';
	import { scooterStorage } from '../../../stores/preferences';
	import { onMount } from 'svelte';
	export let data;

	scooterStorage.set({
		url: data?.scooter?.url,
		producer: data?.scooter?.producer,
		name: data?.scooter?.name,
		model: data?.scooter?.model,
		hasArticles: data?.scooter?.has_articles,
		hasGraphs: data?.scooter?.has_graphs,
		ccm: data?.scooter?.ccm,
		image: data?.scooter?.main_image?.url_medium
	});
	
	onMount(async () => {
		if ($scooterStorage == null || $scooterStorage.url == '') {
			window.location.href = '/skutr-' + data.slug;
		}

	});
</script>

<svelte:head>
	<title>Technické údaje pro skútr {data?.scooter?.producer} {data?.scooter?.name}, {data?.scooter?.ccm} ccm</title>
	<meta name="description" content="Rozměr a hmotnost válečků, kde je VIN a štítek, olej motorový i převodový, interval výměny, utahovací momenty pro {data?.scooter?.producer} {data?.scooter?.name}, {data?.scooter?.ccm} ccm {data?.scooter?.years ?? ""}"/>
	<meta name="keywords" content="Skútr {data?.scooter?.producer} {data?.scooter?.name}, {data?.scooter?.ccm} ccm, technické údaje, parametry, typ oleje, vin, výrobní štítek, údržba, vůle ventilů, převodový olej, baterie, svíčka, interval, utahovací moment, dotahovací, tlak pneu, rozměr pneu"/>
	<link rel="canonical" href={`https://www.scootland.cz/skutr-${data?.scooter?.url}/technicke-udaje/`} />
	
	<meta property="og:title" content="Technické údaje pro skútr {data?.scooter?.producer} {data?.scooter?.name}, {data?.scooter?.ccm} ccm" />
	<meta property="og:description" content="Rozměr a hmotnost válečků, kde je VIN a štítek, olej motorový i převodový, interval výměny, utahovací momenty pro {data?.scooter?.producer} {data?.scooter?.name}, {data?.scooter?.ccm} ccm {data?.scooter?.years ?? ""}"/>
	<meta property="og:image" content={data?.scooter?.main_image?.url_medium} />
	<meta property="og:type" content="website" />
	<meta property="og:url" content={`https://www.scootland.cz/skutr-${data?.scooter?.url}/technicke-udaje/`}/>
	<meta property="og:suite_name" content="Scootland"/>
	<meta property="og:type" content="website" />
	
	
	
	
</svelte:head>

<Breadcrumb
	breadcrumbs={[
		{ name: 'Díly na konkrétní skútr', link: '/skutry' },
		{ name: $scooterStorage.producer, link: '/skutry/' + $scooterStorage.producer },
		{
			name: $scooterStorage.ccm + ' ccm',
			link: '/skutry/' + $scooterStorage.producer + '/' + $scooterStorage.ccm
		},
		{ name: $scooterStorage.model, link: '/skutr-' + $scooterStorage.url },
		{ name: 'Technické parametry', link: '/skutr-' + $scooterStorage.url + '/technicke-udaje' }
	]}
/>

<ScooterDetailNavigator selected="technicke-udaje" />

<section>
	<div class="container mx-auto px-2 pb-16">
		<div class="mx-auto md:w-4/5">
			<div class="bg-graybg w-full px-3 py-6 lg:px-10">
				<h1 class="block font-bold text-xl md:text-3xl mb-1 uppercase md:mb-2.5 mdmax:text-center" align="center">Technické údaje {data?.scooter?.producer}
					{data?.scooter?.name}, {data?.scooter?.ccm} ccm</h1>
				<p align="center">Našli jste chybějící údaj a znáte ho? Prosíme, doplňte jej a pomozte tak i ostatním.</p>
				<h2 class="my-10 mt-8 block w-full text-center text-xl font-bold sm:text-2xl">Motor</h2>
				<div class="mt-6 w-full bg-white">
					<table class="w-full">
						<tbody>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Válečky variátoru"
								value="{data.technical.roller_size} - {data.technical.roller_weight}"
								unit="gr"
							/>
							<TechnicalParameter scooterName={data?.scooter.url} name="Olej motorový" value={data.technical.oil?.toUpperCase()} />
							<TechnicalParameter scooterName={data?.scooter.url} name="Olejový filtr" isSearch={true} value={data.technical.oil_filter} />
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Objem motorového oleje"
								value={data.technical.oil_amount}
								unit="L"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Interval výměny oleje"
								value={data.technical.interval}
								unit="km"
							/>
							<TechnicalParameter scooterName={data?.scooter.url} name="Olej převodový" value={data.technical.gear_oil?.toUpperCase()} />
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Objem převodového oleje"
								value={data.technical.gear_amount}
								unit="L"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Interval seřízení ventilů"
								value={data.technical.ventily_interval}
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Interval výměny rozvodů"
								value={data.technical.rozvody_interval}
							/>
							<TechnicalParameter scooterName={data?.scooter.url} name="Typ motoru" value={data.technical.stroke} />
							<TechnicalParameter scooterName={data?.scooter.url} name="Chlazení" value={data.technical.cooling} />
						</tbody>
					</table>
				</div>

				<h2 class="my-10 block w-full text-center text-xl font-bold sm:text-2xl">Karoserie</h2>
				<div class="mt-6 w-full bg-white">
					<table class="w-full">
						<tbody>
							<TechnicalParameter scooterName={data?.scooter.url} name="Vin rám (pozice)" value={data.technical.vin} />
							<TechnicalParameter scooterName={data?.scooter.url} name="Vin štítek (pozice)" value={data.technical.stitek} />
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Pneu přední"
								value="{data.technical.tyre_front} ({data.technical.speed_front})"
								unit="L"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Tlak pneu přední"
								value={data.technical.pressure_front}
								unit="Bar"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Pneu zadní"
								value="{data.technical.tyre_rear} ({data.technical.speed_rear})"
								unit="L"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Tlak pneu zadní"
								value={data.technical.preassure_rear}
								unit="Bar"
							/>
							<TechnicalParameter scooterName={data?.scooter.url} name="Baterie" isSearch={true} value={data.technical.battery?.toUpperCase()} />
							<TechnicalParameter scooterName={data?.scooter.url} name="Olej přední vidlice" value={data.technical.fork_oil} />
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Množství oleje v kluzáku"
								value={data.technical.fork_amount}
							/>
						</tbody>
					</table>
				</div>

				<h2 class="my-10 block w-full text-center text-xl font-bold sm:text-2xl">
					Utahovací momenty
				</h2>
				<div class="mt-6 w-full bg-white">
					<table class="w-full">
						<tbody>
							<TechnicalParameter scooterName={data?.scooter.url} name="Variator" value={data.technical.vario_nm} />
							<TechnicalParameter scooterName={data?.scooter.url} name="Spojka" value={data.technical.spojka_nm} />
							<TechnicalParameter scooterName={data?.scooter.url} name="Spojkový Zvon" value={data.technical.zvon_nm} />
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Hlava válce - 1. stupeň"
								value={data.technical.hlava_nm_1}
								unit="(4x)"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Hlava válce - 2. stupeň"
								value={data.technical.hlava_nm_2}
								unit="(4x)"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Hlava válce - 3. stupeň"
								value={data.technical.hlava_nm_3}
								unit="(4x)"
							/>
							<TechnicalParameter scooterName={data?.scooter.url}
								name="Hlava válce - 4. stupeň"
								value={data.technical.hlava_nm_4}
								unit="(4x)"
							/>
						</tbody>
					</table>
				</div>

				<h2 class="mt-8 block w-full text-center text-xl font-bold sm:text-2xl">
					Tabulka utahovacích momentů
				</h2>
				<p class="w-full text-center">
					V tabulce najdete utahovací momenty šroubů dle normy ČSN dle průměru stoupání závitu.
				</p>
				<div class="mt-6 w-full bg-white">
					<table class="w-full">
						<thead class="bg-primary">
							<tr>
								<td class="w-full p-3 font-bold md:w-1/2">Rozměr šroubového závitu</td>
								<td class="w-full p-3 text-right font-bold md:w-1/2"
									>Utahovací moment při kvalitě materiálu (8,8)</td
								>
							</tr>
						</thead>
						<tbody>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M5 (x 0,8)</td>
								<td class="w-full p-3 text-right md:w-1/2">5,7 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M6 (x 1)</td>
								<td class="w-full p-3 text-right md:w-1/2">9,9 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M7 (x 1)</td>
								<td class="w-full p-3 text-right md:w-1/2">16 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M8 (x 1,25)</td>
								<td class="w-full p-3 text-right md:w-1/2">24 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M8 (x 1)</td>
								<td class="w-full p-3 text-right md:w-1/2">26 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M10 (x 1,5)</td>
								<td class="w-full p-3 text-right md:w-1/2">48 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M10 (x 0,75)</td>
								<td class="w-full p-3 text-right md:w-1/2">57 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M10 (x 1)</td>
								<td class="w-full p-3 text-right md:w-1/2">54 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M10 (x 1,25)</td>
								<td class="w-full p-3 text-right md:w-1/2">51 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M12 (x 1,75)</td>
								<td class="w-full p-3 text-right md:w-1/2">85 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M12 (x 1)</td>
								<td class="w-full p-3 text-right md:w-1/2">97 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M12 (x 1,25)</td>
								<td class="w-full p-3 text-right md:w-1/2">93 Nm</td>
							</tr>
							<tr class="border-graybg border-b">
								<td class="w-full p-3 md:w-1/2">M12 (x 1,5)</td>
								<td class="w-full p-3 text-right md:w-1/2">89 Nm</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div class="border-b border-gray-200 py-12 items-center text-center">
                    <img src="/images/volba-skutru/logo1.png" class="inline-block" alt="Aprillia" />
                </div> -->
				
			</div>
		</div>
	</div>
</section>

